import * as React from 'react';

import classnames from 'classnames';

import {Checkbox} from 'shells/checkbox/checkbox';
import {colors} from 'shells/colors/colors';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {ProgressBar} from 'shells/progress-bar/progress-bar';
import {Body} from 'shells/typography/body';

import {getProgressBarPercent, getUsageText} from './helpers';

type Props = {
    setIsEnabled: (isEnabled: boolean) => void;
    isEnabled: boolean;
    title: string;
    unit: string;
    description: string;
    link: string | null | undefined;
    remaining?: number | null | undefined;
    limit?: number | null | undefined;
    alternateUsageSummary?: string;
};

export function AiUsageSection(props: Props) {
    const progressBarClassNames = classnames({
        disabled: !props.isEnabled,
    });

    const handleCheckboxChange = (checked: boolean) => {
        props.setIsEnabled(checked);
    };

    const percentComplete = getProgressBarPercent(props.limit, props.remaining);
    const usageText = getUsageText(props.limit, props.remaining, props.unit);

    return (
        <StackLegacy spacing={8}>
            <StackLegacy isHorizontal={true} spacing={8} alignCenter={true}>
                <Checkbox
                    label={props.description}
                    checked={props.isEnabled}
                    onChange={handleCheckboxChange}
                />
                {props.link && (
                    <div className='flex align-center'>
                        <Link href={props.link} newTab={true} variant='primary' size='small'>
                            Learn more
                        </Link>
                    </div>
                )}
            </StackLegacy>
            {props.alternateUsageSummary ? (
                <Body color='light' size='small'>
                    {props.alternateUsageSummary}
                </Body>
            ) : (
                <div className={progressBarClassNames}>
                    <Body isBold={true} color='dark' size='small'>
                        {props.title}
                    </Body>
                    <ProgressBar
                        percentComplete={percentComplete}
                        height={4}
                        roundedCorners={true}
                        showPercentage={true}
                        backgroundColor={colors.offWhiteDk}
                        color={colors.aiBlue}
                    />
                    <Body color='light' size='small'>
                        {usageText}
                    </Body>
                </div>
            )}
        </StackLegacy>
    );
}
